<template>
	<div>
		<base-header type="gradient-dbm" class="pb-6 pb-8 pt-5 pt-md-8"/>

		<div class="container-fluid mt--7" @click="uploadSelected = null">
			<div class="row">
				<div class="col" v-bind:style="{cursor:pointer2}">
					<div class="card shadow">
						<div class="card-header border-0">
							<div class="row align-items-center">
								<div class="col">
									<h3 class="mb-0">
										Cargas masivas
									</h3>
								</div>
							</div>
							<div class="dropdown-divider" style="margin-top: 20px"></div>
							<div class="row" style="margin-top: 20px">
								<div class="col-xl-4 col-lg-4 col-md-4">
									<div class="card card-stats mb-4 mb-xl-2" @click.stop="uploadSelected = 'commissions'">
									<card :class="uploadSelected=='commissions' ? 'border-2 btn-sm' : 'border-2 btn-primary btn-sm'" shadow body-classes="py-4">
											<div class="row">
												<div class="col">
													<h6 class="card-title text-uppercase mb-1">Cargar</h6>
													<span class="h2 font-weight-bold mb-0">Comisiones</span>
												</div>
												<div class="col-auto">
													<div class="icon icon-shape bg-warning text-white">
														<i class="fas fa-donate"></i>
													</div>
												</div>
											</div>
											<dropbox v-if="uploadSelected=='commissions'" type="csv" buttonText="Cargar" v-on:uploadFile="uploadMassiveFile"/>
											<div v-else class="col-lg2" style="margin-top: 30px">
												<span class="h5 font-weight-bold text-muted">Cargas recientes:</span>
												<h4>{{uploadData+" comisiones"}}</h4>
											</div>
										</card>
									</div>
								</div>
								<div class="col-xl-4 col-lg-4 col-md-4">
									<div class="card card-stats mb-4 mb-xl-2" @click.stop="uploadSelected = 'pushNotif'">
									<card :class="uploadSelected=='pushNotif' ? 'border-2 btn-sm' : 'border-2 btn-primary btn-sm'" shadow body-classes="py-4">
											<div class="row">
												<div class="col">
													<h6 class="card-title text-uppercase mb-1">Cargar</h6>
													<span class="h3 font-weight-bold mb-0">Notificaciones push</span>
												</div>
												<div class="col-auto">
													<div class="icon icon-shape bg-success text-white">
														<i class="fas fa-bell"></i>
													</div>
												</div>
											</div>
											<div v-if="uploadSelected=='pushNotif'" class="col-lg2" style="margin-top: 30px">
												<base-input alternative=""
														placeholder="Users ID separados por coma..."
                                                        label="Destinatarios:"
                                                        input-classes="form-control-alternative"
                                                        v-model="massivePN.users"/>
												<base-input alternative=""
														placeholder="Escribe un titulo..."
                                                        label="Titulo:"
                                                        input-classes="form-control-alternative"
                                                        v-model="massivePN.title"/>
												<base-input alternative=""
														placeholder="Escribe un mensaje..."
                                                        label="Mensaje:"
                                                        input-classes="form-control-alternative"
                                                        v-model="massivePN.message"/>
												<base-button slot="title" type="success" class="btn" size="sm" v-on:click="sendMassivePushNotifications()">
													Enviar
												</base-button>
												<!--span class="h5 font-weight-bold text-muted">Cargas recientes:</span>
												<h4>{{uploadData+" Notificaciones"}}</h4-->
											</div>
											<!--dropbox v-if="uploadSelected=='commissions'" type="csv" buttonText="Cargar" v-on:uploadFile="uploadMassiveFile"/-->
											<div v-else class="col-lg2" style="margin-top: 30px">
												<span class="h5 font-weight-bold text-muted">Cargas recientes:</span>
												<h4>{{uploadData+" Notificaciones"}}</h4>
											</div>
										</card>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import Dropbox from '../components/Dropbox'	
	export default {
		name: 'massive-loads',
		components: {
			Dropbox
		},
		data() {
			return {
				uploadSelected: null,
				uploadData: 0,
				pointer: 'pointer',
				pointer2: 'default',
				massivePN: {
					users: "",
					title: "",
					message: "",
				}

			};
		},
		methods: {
			uploadMassiveFile(obj){
				let file = obj.file
				let url = this.$v.SERVER + this.$v.ADMIN_OPS.UPLOAD_CSV + "?filename=" + file.name
				this.$showLoader(true)
				this.$axios.get(url).then(response => {
					this.$showLoader(false)
					if (response.status == 200){
						let dataUrl = response.data
						
						this.$axios.put(dataUrl, file, {'Content-Type': file.type}).then(putObjectResponse => {
							this.$showLoader(false)
							if (putObjectResponse.status === 200) {
								let applyUrl = this.$v.SERVER + this.$v.ADMIN_OPS.APPLY_COMMISSIONS_CSV
								this.$axios.post(applyUrl, {'filename': file.name}).then(response => {
									let data = response.data
									console.log("data");
									if (data[this.$v.API_SUCCESS]) {
										this.$notify({
											text: "Carga exitosa",
											type: 'success'
										})
										this.uploadData = data[this.$v.API_ROW]
										this.uploadSelected=null
									} else {
										this.$notify({
											text: "No se logró postear el archivo",
											type: 'warn'
										})
									}
								})
							} else {
								this.$notify({
									text: "Algo salió mal",
									type: 'warn'
								})
							}
						}).catch(err => {
							console.log(err)
							this.$notify({
								text: "No se lograron enviar las notificaciones",
								type: 'warn'
							})
						})
					}
				})
			},
			sendMassivePushNotifications() {
				if(!this.massivePN.users || !this.massivePN.title || !this.massivePN.message){
					this.$notify({text: "¡Debe llenar todos los campos!", type: 'warn'})
					return
				}
                this.$showLoader(true)
                let url = this.$v.SERVER + this.$v.SELLER_OPS.SEND_MASSIVE_PUSH_NOTIFICATION
                let request = {
                    users: JSON.parse("["+this.massivePN.users+"]"),
					title: this.massivePN.title,
					message: this.massivePN.message
				}
				console.log(request);
				this.$axios.post(url, request).then(response => {
                    this.$showLoader(false)
					let data = response.data
					console.log(data);
                    if (data[this.$v.API_SUCCESS]) {
                        this.$notify({
                            text: "Notificaciones enviadas exitosamente",
                            type: 'success'
						})
						this.uploadSelected=null
                    } else {
                        this.$notify({
                            text: "Algo salió mal",
                            type: 'error'
                        })
                    }
                })
            },
		}
	};
</script>
<style></style>